import React from 'react';
import PropTypes from 'prop-types';
import {TableRow} from '../table';
import './SearchRow.scss';

const SearchRow = ({className, linkTo, children, dataQa}) => {
    return (
        <TableRow
            className={`search-row ${className}`}
            linkTo={linkTo}
            dataQa={dataQa}
        >
            {children}
        </TableRow>
    );
};

SearchRow.propTypes = {
    className: PropTypes.string,
    linkTo: PropTypes.object,
    dataQa: PropTypes.string,
};

SearchRow.defaultProps = {
    className: '',
    linkTo: null,
    dataQa: '',
};

export default SearchRow;
